import { useEffect, useRef, useState } from 'react';

const HomePageImageContent = ({
    imageUrl,
    title,
    content,
  }: {
    imageUrl: string;
    title: string;
    content: React.ReactNode;
  }) => {
     return (
    <div
      style={{
        paddingLeft: "clamp(.2rem, 6vw, 8rem)",
        paddingRight: "clamp(.2rem, 6vw, 8rem)",
        paddingTop: "clamp(.2rem, 2vw, 6rem)",
        paddingBottom: "clamp(.2rem, 2vw, 4rem)",
      }}
      className="grid grid-cols-11 items-start mb-4 "
    >
      <div className="col-span-11 lg:col-span-5 py-2 flex justify-center lg:justify-start">
        <figure>
          <img
            className="w-[clamp(300px,50vw,600px)] h-[clamp(200px,30vw,400px)] rounded-lg bg-white object-cover"
            src={imageUrl}
            alt={title}
          />
        </figure>
      </div>
      <div className="col-span-11 lg:col-start-7 lg:col-span-5 py-4">
        <p className="title-text-size text-custom-secolor animated-content">
          {title}
        </p>
        <div className="custom__divider pb-4">
          <h1></h1>
        </div>
       <div className="text-md text-justify content-text-size break-normal leading-relaxed">
    {content}
  </div>
      </div>
    </div>
  );
  };
  
  export default HomePageImageContent;
  